<template>
  <div class="notifications" v-if="enabled">
    <template v-if="localNotification">
      <NotificationCard
        :message="localNotification.content"
        :messageType="localNotification.type"
        :dismissFn="dismiss"
      />
    </template>
    <template v-else-if="currentNotification">
      <NotificationCard
        :message="currentNotification.content"
        :messageType="currentNotification.type"
        :dismissFn="dismiss"
      />
    </template>
  </div>
</template>

<script lang="ts">
import { getFlashMessages } from '@/api/v1/flash-messages'
import { getNextToaster } from '@/api/v1/toaster'
import Cookies from '@/lib/cookies/cookies'
import { defineComponent, nextTick } from 'vue'
import { TOASTER, NOTIFICATION_KIND } from '@/constants'
import NotificationCard from './NotificationCard.vue'
import store from '@/store'
import notificationGetters from '@/store/notificationModule/getterTypes'
import notificationMutations from '@/store/notificationModule/mutationTypes'
import { Notification, MessageTypes } from '@/types'

let cNotifType: any = null

export default defineComponent({
  name: 'Notifications',
  components: { NotificationCard },
  data() {
    return {
      MessageTypes,
      hasLocalNotif: false,
      currentNotification: cNotifType,
    }
  },
  async mounted() {
    this.currentNotification = await this.getFlashMessage()
  },
  computed: {
    localNotification(): Notification | null {
      return store.getters[notificationGetters.NEXT.NAMESPACED]
    },
    enabled(): boolean {
      return (
        !this.$route.meta.hideDistractions || this.localNotification !== null
      )
    },
  },
  methods: {
    async getFlashMessage(): Promise<any> {
      if (this.$route.meta.hideDistractions) return null

      const flashMessageResp = await getFlashMessages()

      if (flashMessageResp.data) {
        return flashMessageResp.data
      } else {
        return await this.getToaster()
      }
    },
    async getToaster(): Promise<any> {
      if (this.$route.meta.hideDistractions) return null

      const toasterResp = await getNextToaster()
      return toasterResp.data
    },
    async dismiss(): Promise<void> {
      if (this.currentNotification?.kind === NOTIFICATION_KIND.TOASTER) {
        const key = `${TOASTER.COOKIE_PREFIX}${this.currentNotification.name}`

        Cookies.set(key, TOASTER.COOKIE_VALUE)
      }

      if (this.localNotification) {
        store.commit(
          notificationMutations.REMOVE.NAMESPACED,
          this.localNotification
        )
      }

      this.currentNotification = null
      nextTick(async () => {
        this.currentNotification = await this.getToaster()
      })
    },
  },
})
</script>

<style scoped lang="postcss">
.notifications {
  @apply fixed bottom-0 left-0 p-3 z-topLayer pointer-events-none w-full;
}
</style>
